import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import * as globals from '@reusable/services/globals';
import { Injectable, EventEmitter } from '@angular/core';
import { map } from 'rxjs/operators';
@Injectable()
export class CarCustomerService {
  responseData: any;
  handleError: any;

  constructor(private router: Router, private httpClient: HttpClient, private gtn: globals.GetTokenNow) {}

  listModels(sort, records, pageNumber, queries?) {
    const headers = this.gtn.getHeaders();
    headers['params'] = queries;
    return this.httpClient
      .get(`${globals.domain}/core/cp/models/sortBy-${sort}/${records}/${pageNumber}/`, headers)
      .pipe(map(res => res as any));
  }

  listModelDetails(body, page = 1, queries?) {
    const headers = this.gtn.getHeaders();
    headers['params'] = {
      ...queries,
      ...body
    };
    return this.httpClient.get(`${globals.domain}/core/catalog-parts/cars/sortBy-order/30/${page}/`, headers).pipe(map(res => res as any));
  }

  viewCarDetails(body, queries?) {
    const headers = this.gtn.getHeaders();
    headers['params'] = queries;
    return this.httpClient.post(`${globals.domain}/core/cp/car/`, body, headers).pipe(map(res => res as any));
  }

  getPrice(internalModeId) {
    const headers = this.gtn.getHeaders();
    return this.httpClient.get(`${globals.domain}/core/models/${internalModeId}/premium-price/`, headers).pipe(map(res => res as any));
  }

  FilterModelDetails(queries?) {
    const headers = this.gtn.getHeaders();
    headers['params'] = queries;
    return this.httpClient.get(`${globals.domain}/core/catalog-parts/filter/car-parameters/`, headers).pipe(map(res => res as any));
  }

  viewCar(modelId) {
    const headers = this.gtn.getHeaders();
    return this.httpClient.get(`${globals.domain}/core/models/${modelId}/view`, headers).pipe(map(res => res as any));
  }

  decodeCar(body) {
    const headers = this.gtn.getHeaders();
    return this.httpClient.post(`${globals.domain}/cars/decode`, body, headers).pipe(map(res => res as any));
  }
}